var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.01802 5.76953C2.95006 7.6208 4.87784 9.42956 6.76099 11.2808C9.07561 13.5551 11.1756 13.504 13.4222 11.1342C15.0779 9.38917 16.7889 7.69519 18.4786 5.98208C18.5764 5.88431 18.6954 5.80779 18.925 5.625C18.9547 6.02033 18.9951 6.31365 18.9951 6.60483C18.9993 9.18938 19.0036 11.7739 18.9951 14.3564C18.9866 17.0854 17.5264 18.5647 14.825 18.5711C11.5326 18.5796 8.24031 18.586 4.94798 18.569C2.61424 18.5562 1.06478 17.0812 1.02653 14.7474C0.975515 11.7399 1.01377 8.73241 1.01377 5.76528L1.01802 5.76953Z",
    fill: "#787878"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.50488 3.94744C2.32743 2.59991 3.26688 2.00691 4.54003 2.00478C8.18518 1.99841 11.8282 1.99841 15.4733 2.00478C16.7465 2.00691 17.6859 2.59991 18.4894 3.91344C16.1344 6.20467 13.7794 8.54267 11.3691 10.819C10.5381 11.6033 9.35205 11.5098 8.48487 10.683C6.15537 8.45978 3.84926 6.21318 1.50488 3.94744Z",
    fill: "#787878"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/emailIcon.17b8c10be0af089c0dce89fbac10c51d.svg";
export { ForwardRef as ReactComponent };